// Error handling utilities for browser extension conflicts

export const suppressExtensionErrors = () => {
  const originalError = console.error;
  const originalWarn = console.warn;

  // eslint-disable-next-line no-console
  console.error = (...args) => {
    const errorMessage = args[0]?.toString() || '';
    if (isExtensionError(errorMessage)) {
      return; // Suppress extension-related errors
    }
    originalError.apply(console, args);
  };

  // eslint-disable-next-line no-console
  console.warn = (...args) => {
    const warnMessage = args[0]?.toString() || '';
    if (isExtensionError(warnMessage)) {
      return; // Suppress extension-related warnings
    }
    originalWarn.apply(console, args);
  };
};

const isExtensionError = (message) => {
  const extensionErrorPatterns = [
    'showPopover',
    'removeChild',
    'Invalid URL',
    'canvas.js',
    'overlay.js',
    'simulator.js',
    'Failed to execute',
    'InvalidStateError',
    'NotFoundError',
    'TypeError: Failed to construct',
    'WebSocketClient.js',
    'agent.js',
    'hook.js',
    'renderer.js',
    'react-refresh-runtime',
  ];

  return extensionErrorPatterns.some(pattern => 
    message.includes(pattern),
  );
};

export const handleGlobalErrors = () => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const errorMessage = event.reason?.message || event.reason?.toString() || '';
    if (isExtensionError(errorMessage)) {
      event.preventDefault(); // Suppress extension-related promise rejections
      return;
    }
  });

  // Handle global errors
  window.addEventListener('error', (event) => {
    const errorMessage = event.error?.message || event.message || '';
    if (isExtensionError(errorMessage)) {
      event.preventDefault(); // Suppress extension-related errors
      return;
    }
  });
};

export const initializeErrorHandling = () => {
  suppressExtensionErrors();
  handleGlobalErrors();
};
